import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6543607a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "indexlayout-left-logo",
  id: "logo",
  style: {"background-color":"#1964a6"}
}, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#fff","font-size":"20px"} }, "cluan-oms")
], -1))
const _hoisted_2 = { class: "indexlayout-left-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sider_menu = _resolveComponent("sider-menu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "indexlayout-left",
    class: _normalizeClass({'narrow': _ctx.collapsed})
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sider_menu, {
        collapsed: _ctx.collapsed,
        topNavEnable: _ctx.topNavEnable,
        belongTopMenu: _ctx.belongTopMenu,
        selectedKeys: _ctx.selectedKeys,
        openKeys: _ctx.openKeys,
        onOpenChange: _ctx.onOpenChange,
        menuData: _ctx.menuData
      }, null, 8, ["collapsed", "topNavEnable", "belongTopMenu", "selectedKeys", "openKeys", "onOpenChange", "menuData"])
    ])
  ], 2))
}